import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useState } from "react";
import AddCustomPeopleModal from "../modals/dashboard-queries/AddCustomPeopleModal";

const useStyles = makeStyles((theme) => ({
    createButton: {
        width: '12ch',
        height: 40,
        borderRadius: 32,
        borderColor: theme.colors.neutral['100'],
        background: '#E0F1F1',
        color: theme.palette.primary.main,
        fontSize: '1rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
    },
}));

const AddPeople: React.FC<{}> = () => {
    const classes = useStyles();
    const [addCustomPeopleModalOpen, setAddCustomPeopleModalOpen] = useState<boolean>(false);

    return (<>
        <Button variant="outlined"
            className={classes.createButton}
            startIcon={<AddCircleOutlineIcon />}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setAddCustomPeopleModalOpen(true);
            }}
            disableRipple>{'Add ...'} </Button>
        {addCustomPeopleModalOpen && (
            <AddCustomPeopleModal
                isOpen={addCustomPeopleModalOpen}
                onClose={() => {
                    setAddCustomPeopleModalOpen(false);
                }}>
            </AddCustomPeopleModal>
        )}
    </>);
}

export default AddPeople;